import { render, staticRenderFns } from "./checkoutOtp.vue?vue&type=template&id=3c9b905a&scoped=true"
import script from "./checkoutOtp.vue?vue&type=script&lang=js"
export * from "./checkoutOtp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9b905a",
  null
  
)

export default component.exports